module.exports = __webpack_public_path__ + "static/monarch-2c0a419e656d00275fcb1bf625e66c28.jpg";